export default "__VITE_ASSET__bop1Rliy__"